/**
 * @generated SignedSource<<d080cf56e193d21bf887e480c8fe2c8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stripeConnectorPage_Query$variables = Record<PropertyKey, never>;
export type stripeConnectorPage_Query$data = {
  readonly stripeConnectionStatus: {
    readonly businessName: string | null | undefined;
    readonly connectUrl: string | null | undefined;
    readonly connected: boolean;
    readonly keyPresent: boolean;
  };
  readonly stripeHealth: {
    readonly anomalies: ReadonlyArray<{
      readonly metric: string;
      readonly month: string;
      readonly note: string;
    }>;
    readonly coverage: ReadonlyArray<{
      readonly charges: number;
      readonly invoices: number;
      readonly month: string;
      readonly newSubs: number;
    }>;
    readonly integrity: {
      readonly customersWithoutSubscription: number;
      readonly orphanCharges: number;
      readonly stubCustomers: number;
      readonly subsMissingPrice: number;
      readonly unknownCountry: number;
    };
    readonly keyPresent: boolean;
    readonly objects: ReadonlyArray<{
      readonly backfillComplete: boolean;
      readonly backfillInProgress: boolean;
      readonly count: number;
      readonly earliest: string | null | undefined;
      readonly highWaterCreated: string | null | undefined;
      readonly lastError: string | null | undefined;
      readonly lastRows: number | null | undefined;
      readonly lastStatus: string | null | undefined;
      readonly latest: string | null | undefined;
      readonly objectType: string;
    }>;
    readonly reconciliation: ReadonlyArray<{
      readonly bank: number;
      readonly diff: number;
      readonly month: string;
      readonly stripe: number;
    }>;
    readonly runs: ReadonlyArray<{
      readonly currentObject: string | null | undefined;
      readonly dataFrom: string | null | undefined;
      readonly dataTo: string | null | undefined;
      readonly durationMs: number | null | undefined;
      readonly error: string | null | undefined;
      readonly finishedAt: string | null | undefined;
      readonly mode: string;
      readonly rows: ReadonlyArray<{
        readonly count: number;
        readonly objectType: string;
      }>;
      readonly rowsProcessed: number;
      readonly startedAt: string | null | undefined;
      readonly status: string;
    }>;
    readonly sanity: {
      readonly activeLogos: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly churnedLogos: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly mrr: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly newCustomers: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
      readonly volume: ReadonlyArray<{
        readonly month: string;
        readonly value: number | null | undefined;
      }>;
    };
    readonly tierCoverage: {
      readonly known: number;
      readonly pct: number;
      readonly unknown: number;
    };
  };
};
export type stripeConnectorPage_Query = {
  response: stripeConnectorPage_Query$data;
  variables: stripeConnectorPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connectUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keyPresent",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMs",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowsProcessed",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentObject",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataFrom",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataTo",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "earliest",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latest",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highWaterCreated",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backfillComplete",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backfillInProgress",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastStatus",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastError",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastRows",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoices",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "charges",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newSubs",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stripe",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bank",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diff",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orphanCharges",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subsMissingPrice",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customersWithoutSubscription",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stubCustomers",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownCountry",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "known",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknown",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pct",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v40 = [
  (v24/*: any*/),
  (v39/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metric",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v44 = [
  (v24/*: any*/),
  (v39/*: any*/),
  (v43/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "stripeConnectorPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeConnectionStatus",
        "kind": "LinkedField",
        "name": "stripeConnectionStatus",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeHealth",
        "kind": "LinkedField",
        "name": "stripeHealth",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSyncRun",
            "kind": "LinkedField",
            "name": "runs",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StripeRowCount",
                "kind": "LinkedField",
                "name": "rows",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeObjectStatus",
            "kind": "LinkedField",
            "name": "objects",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeCoverageMonth",
            "kind": "LinkedField",
            "name": "coverage",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeReconciliationMonth",
            "kind": "LinkedField",
            "name": "reconciliation",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeIntegrity",
            "kind": "LinkedField",
            "name": "integrity",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeTierCoverage",
            "kind": "LinkedField",
            "name": "tierCoverage",
            "plural": false,
            "selections": [
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSanity",
            "kind": "LinkedField",
            "name": "sanity",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "mrr",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "volume",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "newCustomers",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "churnedLogos",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "activeLogos",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeAnomaly",
            "kind": "LinkedField",
            "name": "anomalies",
            "plural": true,
            "selections": [
              (v41/*: any*/),
              (v24/*: any*/),
              (v42/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "stripeConnectorPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeConnectionStatus",
        "kind": "LinkedField",
        "name": "stripeConnectionStatus",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v43/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StripeHealth",
        "kind": "LinkedField",
        "name": "stripeHealth",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSyncRun",
            "kind": "LinkedField",
            "name": "runs",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StripeRowCount",
                "kind": "LinkedField",
                "name": "rows",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeObjectStatus",
            "kind": "LinkedField",
            "name": "objects",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeCoverageMonth",
            "kind": "LinkedField",
            "name": "coverage",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeReconciliationMonth",
            "kind": "LinkedField",
            "name": "reconciliation",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeIntegrity",
            "kind": "LinkedField",
            "name": "integrity",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeTierCoverage",
            "kind": "LinkedField",
            "name": "tierCoverage",
            "plural": false,
            "selections": [
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeSanity",
            "kind": "LinkedField",
            "name": "sanity",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "mrr",
                "plural": true,
                "selections": (v44/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "volume",
                "plural": true,
                "selections": (v44/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "newCustomers",
                "plural": true,
                "selections": (v44/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "churnedLogos",
                "plural": true,
                "selections": (v44/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MetricPoint",
                "kind": "LinkedField",
                "name": "activeLogos",
                "plural": true,
                "selections": (v44/*: any*/),
                "storageKey": null
              },
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeAnomaly",
            "kind": "LinkedField",
            "name": "anomalies",
            "plural": true,
            "selections": [
              (v41/*: any*/),
              (v24/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          (v43/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ddc9296e910d8ee647477cb58538293a",
    "id": null,
    "metadata": {},
    "name": "stripeConnectorPage_Query",
    "operationKind": "query",
    "text": "query stripeConnectorPage_Query {\n  stripeConnectionStatus {\n    connected\n    businessName\n    connectUrl\n    keyPresent\n    id\n  }\n  stripeHealth {\n    keyPresent\n    runs {\n      mode\n      status\n      startedAt\n      finishedAt\n      durationMs\n      error\n      rowsProcessed\n      currentObject\n      dataFrom\n      dataTo\n      rows {\n        objectType\n        count\n        id\n      }\n      id\n    }\n    objects {\n      objectType\n      count\n      earliest\n      latest\n      highWaterCreated\n      backfillComplete\n      backfillInProgress\n      lastStatus\n      lastError\n      lastRows\n      id\n    }\n    coverage {\n      month\n      invoices\n      charges\n      newSubs\n      id\n    }\n    reconciliation {\n      month\n      stripe\n      bank\n      diff\n      id\n    }\n    integrity {\n      orphanCharges\n      subsMissingPrice\n      customersWithoutSubscription\n      stubCustomers\n      unknownCountry\n      id\n    }\n    tierCoverage {\n      known\n      unknown\n      pct\n      id\n    }\n    sanity {\n      mrr {\n        month\n        value\n        id\n      }\n      volume {\n        month\n        value\n        id\n      }\n      newCustomers {\n        month\n        value\n        id\n      }\n      churnedLogos {\n        month\n        value\n        id\n      }\n      activeLogos {\n        month\n        value\n        id\n      }\n      id\n    }\n    anomalies {\n      metric\n      month\n      note\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e1622450ee5154e7259c5755873b7ce";

export default node;
